function loadViewTapi(view) {
    return () => import( /* webpackChunkName: "tapi-[request]" */ `@/views/Tapi/${view}`)
}

const routes = [
    {
        path: '/tapi',
        name: 'Tapi',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadViewTapi('Main/Index.vue')
    },
    {
        path: '/kelas-tapi',
        name: 'TapiClass',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi']
        },
        component: loadViewTapi('TapiClass/Index.vue')
    },
    {
        path: '/kelas-tapi/:tapi_class_id',
        name: 'TapiClassDetail',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi']
        },
        component: loadViewTapi('TapiClassDetail/Index.vue')
    },
    {
        path: '/rubrik-tapi',
        name: 'TapiRubricCategory',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi']
        },
        component: loadViewTapi('RubricCategory/Index.vue')
    },
    {
        path: '/rubrik-tapi/:category_id',
        name: 'TapiRubricField',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi']
        },
        component: loadViewTapi('RubricField/Index.vue')
    },
    {
        path: '/bimbingan-tapi',
        name: 'ListUserBimbingan',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadViewTapi('Guidance/ListUserBimbingan.vue')
    },
    {
        path: '/bimbingan-tapi/:tapi_lecture_id',
        name: 'ListBimbingan',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadViewTapi('Guidance/ListBimbingan.vue')
    },
    {
        path: '/bimbingan-tapi/:tapi_lecture_id/form',
        name: 'FormBimbinganTapi',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadViewTapi('Guidance/FormBimbingan.vue')
    },
    {
        path: '/bimbingan-tapi/:tapi_lecture_id/form/:tG_id',
        name: 'ResponseBimbinganTapi',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadViewTapi('Guidance/ResponseBimbingan.vue')
    },
    
    {
        path: '/penilaian-tapi',
        name: 'TapiStudentList',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadViewTapi('StudentList/Index.vue')
    },
    {
        path: '/penilaian-tapi/:tapi_lecture_id',
        name: 'TapiStudentListForm',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadViewTapi('StudentList/Form.vue')
    },
    {
        path: '/penilaian-tapi/:tapi_lecture_id/report',
        name: 'TapiStudentListReport',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: ['kaprodi','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadViewTapi('StudentList/Report.vue')
    },
]

export default routes